import { createSlice } from "@reduxjs/toolkit";

const timeslotsSlice = createSlice({
  name: "timeslotsSlice",
  initialState: {
    items: [],
  },
  reducers: {
    populateData(state, action) {
      state.items = action.payload;
    },
  },
});

export const sliceActions = timeslotsSlice.actions;

export default timeslotsSlice.reducer;
